import { rem } from 'polished'
import styled from 'styled-components'

export const ConstrainedMapView = styled.div`
  max-width: 260px;
  box-shadow: 0 2px 7px 1px rgb(0 0 0 / 30%);
`

export const Container = styled.div`
  position: relative;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  box-shadow: ${props => props.theme.shadow.flat.small};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${(props) => props.theme.borderRadius.M};
  overflow: hidden;
  height: max-content;
  width: ${rem(260)};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  gap: ${rem(8)};
  padding: ${rem(16)};

  & > span {
    width: min-content;
  }

  & > :last-child {
    margin-top: ${rem(8)};
  }
`

export const Image = styled.img`
  position: absolute;
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
`

export const ImageContainer = styled.div`
  position: relative;
  align-self: stretch;
  width: 100%;
  height: ${rem(160)};
`

export const ImageOverlayContainer = styled.div`
  position: absolute;
  top: ${rem(12)};
  inset-inline: ${rem(12)};
`

export const TimePlace = styled.div`
  display: flex;
  justify-content: space-between;

  & > section:nth-child(odd) {
    display: flex;
    width: max-content;
    flex-direction: column;
    gap: ${rem(4)};
  }

  & > section:nth-child(even) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${rem(4)};
  }
`
